import { Alert } from 'antd';

const ErrorMessage = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <Alert
        message={message}
        type="error"
        showIcon
        closable
        onClose={onClose}
      />
    </div>
  );
};

export default ErrorMessage;
